import { apiRequestV2, apiEndPoints, methodType } from "./_apiConfig";

export const loginRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.authLogin,
        data,
        false
    );
};

export const logoutRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.authLogout,
        data,
        true
    );
};

export const signupRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.authSignup,
        data,
        false
    );
};

export const otpVerificationRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.authVerifyMail,
        data,
        false
    );
};

export const changePasswordRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.authChangePassword,
        data,
        true
    );
};

export const resetPasswordRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.resetPassword,
        data,
        false
    );
};

export const resendEmailOtpRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.resendEmailOtp,
        data,
        false
    );
};

export const verifyPasswordResetRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.verifyPasswordReset,
        data,
        false
    );
};

export const verifyEmailRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.authVerifyMail,
        data,
        false
    );
};

export const verifyPhoneOtpRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.verifyPhone,
        data,
        false
    );
};

export const resendPhoneOtpRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.resendOTP,
        data,
        false
    );
};

export const unsubscribeEmailRequest = async (data = {}) => {
    return apiRequestV2(
        methodType.POST,
        apiEndPoints.unsubscribeEmail,
        data,
        false
    );
};